import { useState, useEffect, useCallback, useRef } from 'react';

export function useSticky(fromTop?: number) {
  const [isSticky, setIsSticky] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const cleanupRef = useRef<(() => void) | null>(null);

  const measuredRef = useCallback(
    (node: HTMLElement | HTMLDivElement | null) => {
      if (cleanupRef.current) {
        cleanupRef.current();
      }

      if (node !== null) {
        const observer = new IntersectionObserver(
          ([event]) => setIsSticky(event.intersectionRatio < 1),
          {
            threshold: [1],
            rootMargin: `-${fromTop ?? 0}px 0px 0px 0px`
          }
        );
        observer.observe(node);
        observerRef.current = observer;
        cleanupRef.current = () => observer.disconnect();
      }
    },
    [fromTop]
  );

  useEffect(() => {
    return () => {
      if (cleanupRef.current) {
        cleanupRef.current();
      }
    };
  }, []);

  return { ref: measuredRef, isSticky };
}
